const pt = {
    _name: 'Português',
    _flag: '🇵🇹',
    // Nav
    'nav.dashboard': 'Painel',
    'nav.pos': 'Ponto de venda',
    'nav.calcul': 'Cálculo de preço',
    'nav.devis': 'Orçamentos / Faturas',
    'nav.devisDeplacement': 'Orçamentos deslocação',
    'nav.commandes': 'Encomendas',
    'nav.addDevice': 'Adicionar dispositivo',
    'nav.reparations': 'Reparações',
    'nav.clients': 'Clientes',
    'nav.stock': 'Stock',
    'nav.addStock': 'Adicionar stock',
    'nav.etiquettes': 'Etiquetas',
    'nav.users': 'Utilizadores',
    'nav.clientPwd': 'Palavras-passe clientes',
    'nav.boutiqueOrders': 'Encomendas loja',
    'nav.caisseHistory': 'Histórico de caixa',
    'nav.database': 'Base de dados',
    'nav.historique': 'Histórico',
    'nav.paiements': 'Pagamentos online',
    'nav.chatClients': 'Chat clientes',
    'nav.chat': 'Mensagens',
    'nav.notes': 'Notas',
    'nav.logout': 'Terminar sessão',
    'nav.quit': 'Sair',
    'nav.admin': 'Administração',
    'nav.navigation': 'Navegação',
    'nav.b2b': 'Gestão B2B',
    'nav.b2bPayments': 'Pagamentos B2B',
    'nav.brandsModels': 'Marcas & Modelos',
    // Common
    'common.save': 'Guardar',
    'common.cancel': 'Cancelar',
    'common.delete': 'Eliminar',
    'common.edit': 'Editar',
    'common.search': 'Pesquisar',
    'common.add': 'Adicionar',
    'common.close': 'Fechar',
    'common.confirm': 'Confirmar',
    'common.loading': 'A carregar...',
    'common.noData': 'Sem dados',
    'common.actions': 'Ações',
    'common.status': 'Estado',
    'common.date': 'Data',
    'common.total': 'Total',
    'common.print': 'Imprimir',
    'common.yes': 'Sim',
    'common.no': 'Não',
    'common.back': 'Voltar',
    'common.next': 'Seguinte',
    'common.validate': 'Validar',
    'common.ref': 'Referência',
    'common.client': 'Cliente',
    'common.phone': 'Telefone',
    'common.email': 'Email',
    'common.price': 'Preço',
    'common.quantity': 'Quantidade',
    'common.amount': 'Montante',
    'common.send': 'Enviar',
    'common.download': 'Descarregar',
    'common.export': 'Exportar',
    'common.refresh': 'Atualizar',
    'common.filter': 'Filtrar',
    'common.all': 'Todos',
    'common.name': 'Nome',
    'common.address': 'Morada',
    'common.description': 'Descrição',
    'common.payment': 'Pagamento',
    'common.paid': 'Pago',
    'common.pending': 'Pendente',
    'common.accepted': 'Aceite',
    'common.refused': 'Recusado',
    // Layout
    'layout.panel': 'Painel de gestão',
    // POS
    'pos.title': 'Ponto de Venda',
    'pos.scanner': 'Scanner',
    'pos.searchProduct': 'Pesquisar um produto (ref, nome, código de barras)...',
    'pos.outOfStock': 'Esgotado',
    'pos.article': 'Artigo',
    'pos.unitPrice': 'Preço unit.',
    'pos.qty': 'Qtd',
    'pos.emptyCart': 'Carrinho vazio',
    'pos.checkout': 'Pagamento',
    'pos.clientOptional': 'Cliente (opcional)',
    'pos.discount': 'Desconto',
    'pos.subtotal': 'Subtotal',
    'pos.validateSale': 'Validar a venda',
    'pos.paymentMode': 'Modo de pagamento',
    'pos.choosePayment': 'Escolha o modo de pagamento:',
    'pos.cash': 'Dinheiro',
    'pos.card': 'Cartão bancário',
    'pos.mixed': 'Misto',
    'pos.totalToCollect': 'Total a cobrar',
    'pos.change': 'Troco',
    'pos.confirmPayment': 'Confirmar pagamento',
    'pos.validating': 'A validar...',
    'pos.lastTicket': 'Último talão',
    'pos.caisseClosed': 'A caixa está fechada. Abra-a a partir do Painel para efetuar vendas.',
    'pos.insufficientCash': 'Montante em dinheiro insuficiente',
    'pos.insufficientCard': 'Montante em cartão insuficiente',
    'pos.mixedMustEqual': 'O pagamento misto deve ser igual ao total',
    'pos.emptyCartAlert': 'Carrinho vazio',
    'pos.selectPayment': 'Escolha um modo de pagamento',
    'pos.saleValidated': 'Venda validada!',
    'pos.adminOverride': 'Autorização do administrador',
    'pos.outOfStockProduct': 'Produto esgotado',
    'pos.adminId': 'ID do administrador',
    'pos.adminCode': 'Código do administrador',
    'pos.manualAdd': 'Adicionar artigo fora de stock',
    'pos.designation': 'Designação',
    'pos.stockInsufficient': 'Stock insuficiente',
    // Devis
    'devis.title': 'Orçamentos & Faturas',
    'devis.subtitle': 'Documentos do cálculo de preço (convertíveis em encomenda).',
    'devis.noDoc': 'Nenhum documento encontrado',
    'devis.type': 'Tipo',
    'devis.convertConfirm': 'Converter este orçamento em encomenda?',
    'devis.orderCreated': 'Encomenda criada',
    'devis.deleteConfirm': 'Eliminar este documento?',
    'devis.deleted': 'Documento eliminado',
    // Devis Déplacement
    'devDep.title': 'Orçamentos deslocação',
    'devDep.subtitle': 'Gestão de orçamentos para reparações ao domicílio',
    'devDep.new': 'Novo orçamento',
    'devDep.edit': 'Editar orçamento',
    'devDep.clientName': 'Nome do cliente',
    'devDep.clientPhone': 'Telefone',
    'devDep.clientEmail': 'Email',
    'devDep.clientAddress': 'Morada',
    'devDep.repairDesc': 'Descrição da reparação',
    'devDep.lines': 'Linhas do orçamento',
    'devDep.addLine': 'Adicionar',
    'devDep.travelFee': 'Custos de deslocação',
    'devDep.sendByEmail': 'Enviar por email',
    'devDep.sending': 'A enviar...',
    'devDep.pdfDevis': 'PDF Orçamento',
    'devDep.pdfBon': 'PDF Nota de encomenda',
    'devDep.pdfFacture': 'PDF Fatura',
    'devDep.searchPlaceholder': 'Pesquisar por ref, nome, email...',
    'devDep.allStatuses': 'Todos os estados',
    'devDep.pending': 'Pendente',
    'devDep.accepted': 'Aceite',
    'devDep.refused': 'Recusado',
    'devDep.depositPaid': 'Sinal pago',
    'devDep.fullyPaid': 'Pago',
    'devDep.stats': 'Estatísticas',
    'devDep.revenues': 'Receitas',
    'devDep.activity30d': 'Atividade dos últimos 30 dias',
    'devDep.remind': 'Relembrar',
    'devDep.remindConfirm': 'Enviar lembrete a clientes com orçamentos pendentes há mais de 3 dias?',
    'devDep.noDevis': 'Nenhum orçamento criado',
    'devDep.noResults': 'Sem resultados',
    'devDep.bon': 'Nota de encomenda',
    'devDep.facture': 'Fatura',
    'devDep.emailSent': 'Email enviado em',
    'devDep.reminderSent': 'Lembrete enviado em',
    // Reparations
    'rep.title': 'Reparações',
    'rep.search': 'Pesquisar uma reparação...',
    'rep.new': 'Nova reparação',
    'rep.deviceRef': 'Ref. dispositivo',
    'rep.brand': 'Marca',
    'rep.model': 'Modelo',
    'rep.problem': 'Problema',
    'rep.technician': 'Técnico',
    'rep.timeline': 'Cronologia',
    // Commandes
    'cmd.title': 'Encomendas',
    'cmd.search': 'Pesquisar uma encomenda...',
    'cmd.piece': 'Peça',
    'cmd.supplier': 'Fornecedor',
    'cmd.deposit': 'Sinal',
    'cmd.remaining': 'Valor restante',
    // Clients
    'clients.title': 'Clientes',
    'clients.search': 'Pesquisar um cliente...',
    'clients.name': 'Nome',
    'clients.address': 'Morada',
    'clients.addClient': 'Novo cliente',
    // Stock
    'stock.title': 'Gestão de Stock',
    'stock.search': 'Pesquisar um artigo...',
    'stock.addArticle': 'Adicionar artigo',
    'stock.category': 'Categoria',
    'stock.buyPrice': 'Preço de compra',
    'stock.sellPrice': 'Preço de venda',
    'stock.available': 'Disponível',
    // Dashboard
    'dash.title': 'Painel',
    'dash.openCaisse': 'Abrir caixa',
    'dash.closeCaisse': 'Fechar caixa',
    'dash.todaySales': 'Vendas de hoje',
    'dash.monthSales': 'Vendas do mês',
    'dash.activeRepairs': 'Reparações ativas',
    'dash.pendingOrders': 'Encomendas pendentes',
    // Login
    'login.title': 'Iniciar sessão',
    'login.username': 'Identificador',
    'login.password': 'Código de acesso',
    'login.submit': 'Entrar',
    'login.clientAccess': 'Acesso cliente',
    'login.staffAccess': 'Acesso pessoal',
    // Language
    'lang.select': 'Idioma',
    // Client Portal
    'client.space': 'Área de Cliente',
    'client.repairs': 'Reparações',
    'client.boutique': 'Loja',
    'client.orders': 'Encomendas',
    'client.messages': 'Mensagens',
    'client.devis': 'Orçamentos',
    'client.trackRepairs': 'Acompanhe as suas reparações',
    'client.noRepairs': 'Nenhuma reparação em curso',
    'client.trackOrders': 'Acompanhe as suas encomendas',
    'client.noOrders': 'Nenhuma encomenda em curso',
    'client.shop': 'Loja online',
    'client.noProducts': 'Nenhum produto disponível',
    'client.addToCart': 'Adicionar ao carrinho',
    'client.yourMessages': 'As suas mensagens',
    'client.noMessages': 'Sem mensagens',
    'client.send': 'Enviar',
    'client.brand': 'Marca',
    'client.model': 'Modelo',
    'client.problem': 'Problema',
    'client.status': 'Estado',
    'client.deposit': 'Sinal',
    'client.remaining': 'Valor restante',
    'client.total': 'Total',
    'client.timeline': 'Cronologia',
    'client.noDevis': 'Nenhum orçamento de momento',
    'client.acceptRefuse': 'Aceitar / Recusar',
    'client.pay': 'Pagar',
    // Landing
    'landing.mobileRepair': 'Reparação móvel na Guiana Francesa',
    'landing.staffSpace': 'ÁREA DE PESSOAL',
    'landing.staffDesc': 'Acesso equipa técnica',
    'landing.clientSpace': 'ÁREA DE CLIENTE',
    'landing.clientDesc': 'Acompanhamento de reparação',
    'landing.businessSpace': 'ÁREA DE EMPRESA',
    'landing.businessDesc': 'Portal B2B',
    'landing.contact': 'Contacto',
    'landing.callWhatsapp': 'Chamada & WhatsApp',
    'landing.writeUs': 'Escreva-nos diretamente',
    'landing.hours': 'Horário de funcionamento',
    'landing.legal': 'Informações legais',
    'landing.capital': 'com um capital de',
    'landing.headquarters': 'Sede',
    'landing.allRights': 'Todos os direitos reservados',
    'landing.heroSubtitle': 'O seu especialista em reparação móvel na Guiana Francesa',
    'landing.mondayFriday': 'Segunda - Sexta',
    'landing.saturday': 'Sábado',
    'landing.sunday': 'Domingo',
    'landing.closed': 'Fechado',
    'landing.companyType': 'Sociedade por Ações Simplificada (SAS)',
    'landing.openMaps': 'Abrir no Maps',
    'landing.rcs': 'RCS',
    'landing.siret': 'SIRET',
    'landing.euid': 'EUID',
    'landing.shopAddress': 'Ponto de venda',
    // Login extra
    'login.clientSpace': 'Área de Cliente',
    'login.businessSpace': 'Área de Empresa',
    'login.staffSpace': 'Área de Pessoal',
    'login.connectYou': 'Iniciar sessão',
    'login.phoneNumber': 'Número de telefone',
    'login.proEmail': 'Email profissional',
    'login.pin': 'Código PIN (4 ou 6 dígitos)',
    'login.pinHint': 'Introduza o seu código pelo teclado ou pelo teclado numérico.',
    'login.connecting': 'A ligar...',
    'login.connect': 'Entrar',
    'login.noAccount': 'Ainda não tem conta?',
    'login.createAccount': 'Criar conta',
    'login.forgotPwd': 'Esqueceu a palavra-passe?',
    'login.notRegistered': 'Ainda não está registado?',
    'login.businessRegister': 'Registo de empresa',
    'login.secure': 'Sessão segura',
    'login.caricature': 'Criar a minha caricatura',
    'login.backHome': 'Voltar à página inicial',
    'login.wrongCredentials': 'Credenciais incorretas',
    'login.pinError': 'O código PIN deve conter 4 ou 6 dígitos',
    'login.b2bPassword': 'Palavra-passe',
    'login.b2bPlaceholder': 'A sua palavra-passe',
    'login.yourId': 'O seu identificador',
    // Dashboard extra
    'dash.hello': 'Olá',
    'dash.loggedAs': 'Sessão iniciada como',
    'dash.caisseOpen': 'Caixa aberta',
    'dash.closeCaisseReminder': 'Lembre-se de fechar a caixa',
    'dash.noCaisse': 'Nenhuma caixa aberta',
    'dash.openCaisseTitle': 'Abrir caixa',
    'dash.openTotal': 'Total de abertura',
    'dash.opening': 'A abrir...',
    'dash.open': 'Abrir',
    'dash.searchPlaceholder': 'Pesquisar por referência, cliente, telefone...',
    'dash.noResults': 'Nenhum resultado encontrado',
    'dash.today': 'Hoje',
    'dash.thisMonth': 'Este mês',
    'dash.completed': 'Concluídas',
    'dash.repairsSub': 'reparações',
    'dash.inProgress': 'Em curso',
    'dash.waitingParts': 'à espera de peças incl.',
    'dash.registeredMonth': 'registadas este mês',
    'dash.statsTitle': 'Estatísticas & Análises',
    'dash.statsDesc': 'Volume de negócios, reparações, B2B, clientes',
    'dash.brandsModelsLabel': 'Marcas & Modelos',
    'dash.brandsModelsDesc': 'Gerir o catálogo de dispositivos',
    'dash.b2bPaymentsLabel': 'Pagamentos B2B',
    'dash.b2bPaymentsDesc': 'Acompanhamento de faturas e pagamentos',
    'dash.stockAlerts': 'Alertas de stock',
    'dash.lowStock': 'produtos com stock baixo',
    'dash.outOfStock': 'esgotados',
    'dash.recentRepairs': 'Últimas reparações',
    'dash.noClient': 'Sem cliente',
    'dash.unclosedTitle': 'Caixa não fechada',
    'dash.unclosedNotClosed': 'não foi fechada',
    'dash.contactAdmin': 'Contacte um administrador para a fechar antes de continuar.',
    'dash.mustClose': 'Deve fechá-la antes de poder continuar a trabalhar.',
    'dash.forceClose': 'Fecho forçado',
    'dash.closing': 'A fechar...',
    'dash.closeNormal': 'Fechar normalmente',
    'dash.noCaisseToday': 'Nenhuma caixa aberta hoje.',
    'dash.openQuestion': 'Deseja abrir a caixa agora?',
    'dash.dontOpen': 'Não abrir (continuar)',
    'dash.salesBlocked': 'As vendas estão bloqueadas enquanto a caixa não estiver aberta.',
    'dash.calculation': 'Cálculo',
    'dash.repairs': 'Reparações',
    'dash.addDevice': 'Adicionar',
    'dash.clients': 'Clientes',
    'dash.openedBy': 'aberta por',
    'dash.unknown': 'desconhecido',
    'dash.forceCloseConfirm': 'Forçar o fecho da caixa de',
    'dash.errorForceClose': 'Erro no fecho forçado',
    'dash.errorOpenCaisse': 'Erro ao abrir a caixa',
    // Devis Accept
    'devisAccept.error': 'Erro',
    'devisAccept.notFound': 'Orçamento não encontrado',
    'devisAccept.refused': 'Orçamento recusado',
    'devisAccept.refusedMsg': 'Recusou o orçamento',
    'devisAccept.thanks': 'Obrigado por nos informar.',
    'devisAccept.accepted': 'Orçamento aceite!',
    'devisAccept.acceptedMsg': 'Obrigado por aceitar o orçamento',
    'devisAccept.bonCommande': 'Nota de encomenda',
    'devisAccept.facture': 'Fatura',
    'devisAccept.emailSent': 'Foi enviado um email com a sua nota de encomenda, o código de validação e as suas credenciais.',
    'devisAccept.proceedPayment': 'Proceder ao pagamento',
    'devisAccept.paymentMsg': 'Para finalizar a sua encomenda, efetue um sinal ou o pagamento completo:',
    'devisAccept.deposit50': 'Sinal 50%',
    'devisAccept.fullPayment': 'Pagamento completo',
    'devisAccept.alreadyAccepted': 'Este orçamento já foi aceite.',
    'devisAccept.alreadyRefused': 'Este orçamento foi recusado.',
    'devisAccept.statusMsg': 'Estado do orçamento',
    'devisAccept.payDeposit': 'Pagar sinal 50%',
    'devisAccept.homeRepairQuote': 'Orçamento de reparação ao domicílio',
    'devisAccept.hello': 'Olá',
    'devisAccept.findBelow': 'Encontre abaixo os detalhes do seu orçamento:',
    'devisAccept.designation': 'Designação',
    'devisAccept.travelFee': 'Custos de deslocação',
    'devisAccept.tvaNote': 'IVA não aplicável, art. 293B do CGI. Orçamento válido por 30 dias.',
    'devisAccept.refuse': 'Recusar',
    'devisAccept.accept': 'Aceitar o orçamento',
    'devisAccept.confirmRefuse': 'Tem a certeza que deseja recusar este orçamento?',
    // Payment
    'payment.secure': 'Pagamento seguro',
    'payment.error': 'Erro',
    'payment.backToDevis': 'Voltar ao orçamento',
    'payment.notAccepted': 'Orçamento não aceite',
    'payment.mustAcceptFirst': 'Deve primeiro aceitar o orçamento antes de proceder ao pagamento.',
    'payment.viewDevis': 'Ver orçamento',
    'payment.fullyPaid': 'Fatura totalmente paga',
    'payment.alreadyPaid': 'já está totalmente pago.',
    'payment.accessClient': 'Aceder à sua área de cliente',
    'payment.deposit50': 'Sinal 50%',
    'payment.fullPayment': 'Pagamento completo',
    'payment.devis': 'Orçamento',
    'payment.client': 'Cliente',
    'payment.totalDevis': 'Total do orçamento',
    'payment.alreadyPaidAmount': 'Já pago',
    'payment.remaining': 'Valor restante',
    'payment.depositPercent': 'Sinal (50%)',
    'payment.amountToPay': 'Montante a pagar',
    'payment.pay': 'Pagar',
    'payment.redirecting': 'A redirecionar para o Stripe...',
    'payment.securedBy': 'Pagamento seguro via Stripe',
    'payment.urlNotAvailable': 'URL de pagamento não disponível',
    'payment.creationError': 'Erro na criação do pagamento',
    // Payment success
    'paySuccess.confirmed': 'Pagamento confirmado!',
    'paySuccess.paymentFor': 'O seu pagamento para o orçamento',
    'paySuccess.registered': 'foi registado com sucesso.',
    'paySuccess.depositRegistered': 'Sinal registado!',
    'paySuccess.depositFor': 'O seu sinal para o orçamento',
    'paySuccess.depositDone': 'foi registado.',
    'paySuccess.checking': 'A verificar...',
    'paySuccess.pleaseWait': 'Estamos a verificar o seu pagamento, aguarde por favor.',
    'paySuccess.waitingConfirm': 'A aguardar confirmação',
    'paySuccess.processing': 'O seu pagamento está a ser processado. Receberá um email de confirmação.',
    'paySuccess.totalInvoice': 'Total da fatura',
    'paySuccess.amountPaid': 'Montante pago',
    'paySuccess.remaining': 'Valor restante',
    'paySuccess.payRemaining': 'Pagar o restante',
    'paySuccess.loginClient': 'Inicie sessão na sua área de cliente',
    // Registration
    'register.clientTitle': 'Criar conta de cliente',
    'register.fullName': 'Nome completo',
    'register.phone': 'Telefone',
    'register.email': 'Email (opcional)',
    'register.address': 'Morada (opcional)',
    'register.pin': 'Código PIN (4 ou 6 dígitos)',
    'register.confirmPin': 'Confirmar código PIN',
    'register.creating': 'A criar...',
    'register.createAccount': 'Criar a minha conta',
    'register.alreadyAccount': 'Já tem conta?',
    'register.login': 'Iniciar sessão',
    'register.backHome': 'Voltar à página inicial',
    'register.pinError': 'O código PIN deve conter 4 ou 6 dígitos',
    'register.pinNoMatch': 'Os códigos PIN não coincidem',
    'register.pinMinLength': 'O código PIN deve conter pelo menos 4 dígitos',
    // B2B Registration
    'b2bRegister.title': 'Registo de Empresa',
    'b2bRegister.subtitle': 'Crie a sua conta profissional',
    'b2bRegister.companyName': 'Nome da empresa',
    'b2bRegister.managerName': 'Nome do gerente',
    'b2bRegister.proEmail': 'Email profissional',
    'b2bRegister.phone': 'Telefone',
    'b2bRegister.address': 'Morada',
    'b2bRegister.siret': 'SIRET',
    'b2bRegister.password': 'Palavra-passe',
    'b2bRegister.confirmPassword': 'Confirmar palavra-passe',
    'b2bRegister.kbis': 'Extrato KBIS (PDF)',
    'b2bRegister.kbisDesc': 'Carregue o seu extrato KBIS ou documento comprovativo (PDF)',
    'b2bRegister.dropFile': 'Clique ou arraste o seu ficheiro aqui',
    'b2bRegister.creating': 'Registo em curso...',
    'b2bRegister.submit': 'Registar',
    'b2bRegister.success': 'Registo efetuado!',
    'b2bRegister.successMsg': 'A sua conta empresarial está em validação. Receberá um email de confirmação.',
    'b2bRegister.goLogin': 'Ir para a sessão',
    'b2bRegister.fillAll': 'Preencha todos os campos obrigatórios',
    'b2bRegister.siretError': 'O SIRET deve conter 14 dígitos',
    'b2bRegister.pwdNoMatch': 'As palavras-passe não coincidem',
    'b2bRegister.pwdMinLength': 'A palavra-passe deve conter pelo menos 6 caracteres',
    'b2bRegister.kbisRequired': 'Carregue o seu extrato KBIS',
    'b2bRegister.alreadyAccount': 'Já está registado?',
    // Reset password
    'reset.forgotTitle': 'Palavra-passe esquecida',
    'reset.forgotDesc': 'Receba um link de reposição por email',
    'reset.enterEmail': 'Introduza o seu email',
    'reset.emailSent': 'Email enviado',
    'reset.emailSentMsg': 'Se existir uma conta com este endereço, receberá um email com um link para repor a sua palavra-passe.',
    'reset.linkValid': 'O link é válido durante 1 hora.',
    'reset.backLogin': 'Voltar à sessão',
    'reset.clientEmail': 'Endereço de email da sua conta',
    'reset.sending': 'A enviar...',
    'reset.sendLink': 'Enviar link de reposição',
    'reset.newPwdTitle': 'Nova palavra-passe',
    'reset.newPwdDesc': 'Escolha a sua nova palavra-passe',
    'reset.newPwd': 'Nova palavra-passe',
    'reset.confirmPwd': 'Confirmar palavra-passe',
    'reset.resetting': 'A repor...',
    'reset.resetPwd': 'Repor palavra-passe',
    'reset.pwdReset': 'Palavra-passe reposta',
    'reset.pwdResetMsg': 'A sua palavra-passe foi alterada com sucesso.',
    'reset.pwdMinLength': 'A palavra-passe deve conter pelo menos 4 caracteres',
    'reset.pwdNoMatch': 'As palavras-passe não coincidem',
    'reset.error': 'Ocorreu um erro',
    // B2B Dashboard
    'b2b.welcome': 'Bem-vindo',
    'b2b.newRepair': 'Nova reparação',
    'b2b.registerDevice': 'Registar um dispositivo',
    'b2b.myRepairs': 'As minhas reparações',
    'b2b.viewAll': 'Ver todas as reparações',
    'b2b.recentRepairs': 'Últimas reparações',
    'b2b.noRepairs': 'Sem reparações',
    'b2b.repairRegistered': 'Reparação registada',
    'b2b.reference': 'Referência',
    'b2b.viewDetails': 'Ver detalhes',
    'b2b.anotherRepair': 'Nova reparação',
    'b2b.deviceInfo': 'Informações do dispositivo',
    'b2b.brand': 'Marca',
    'b2b.model': 'Modelo',
    'b2b.backGlass': 'Vidro traseiro',
    'b2b.backGlassBroken': 'Vidro traseiro partido',
    'b2b.backGlassOk': 'Vidro traseiro intacto',
    'b2b.providePart': 'Eu forneço a peça',
    'b2b.partByShop': 'A peça será fornecida pela R.E.Mobiles',
    'b2b.lockCode': 'Código de desbloqueio',
    'b2b.lockTypeCode': 'Código (números/letras)',
    'b2b.lockTypeSchema': 'Padrão',
    'b2b.problem': 'Problema / Descrição',
    'b2b.brokenParts': 'Peças não funcionais',
    'b2b.deliveryMethod': 'Método de entrega',
    'b2b.inStore': 'Na loja',
    'b2b.inStoreDesc': 'Entrega na loja',
    'b2b.postal': 'Envio postal',
    'b2b.postalDesc': 'Com número de rastreio',
    'b2b.pickup': 'Recolha',
    'b2b.pickupDesc': 'Vamos buscar',
    'b2b.trackingNumber': 'Número de rastreio',
    'b2b.pickupAddress': 'Morada de recolha',
    'b2b.devicePhotos': 'Fotos do dispositivo',
    'b2b.addPhotos': 'Clique para adicionar fotos',
    'b2b.additionalNotes': 'Notas adicionais',
    'b2b.submitting': 'A enviar...',
    'b2b.submitRepair': 'Registar a reparação',
    'b2b.brandModelRequired': 'Marca e modelo são obrigatórios',
    'b2b.noRepairFound': 'Nenhuma reparação encontrada',
    'b2b.allStatus': 'Todas',
    'b2b.documents': 'Documentos & Faturas',
    'b2b.documentsDesc': 'Valide as suas notas de encomenda e descarregue as suas faturas',
    'b2b.pendingValidation': 'Notas de encomenda a validar',
    'b2b.enterCode': 'Introduza o código recebido por email para validar cada nota de encomenda.',
    'b2b.validate': 'Validar',
    'b2b.invoices': 'Faturas',
    'b2b.noInvoices': 'Nenhuma fatura disponível',
    'b2b.device': 'Dispositivo',
    'b2b.amount': 'Montante',
    'b2b.date': 'Data',
    'b2b.actions': 'Ações',
    'b2b.paid': 'Paga',
    'b2b.repairAccepted': 'Reparação aceite pelo pessoal',
    'b2b.repairRefused': 'Reparação recusada pelo pessoal',
    'b2b.orderValidated': 'Nota de encomenda validada',
    'b2b.noPhotos': 'Sem fotos',
    'b2b.history': 'Histórico',
    'b2b.repairPrice': 'Preço da reparação',
    'b2b.diagPrice': 'Preço do diagnóstico',
    'b2b.priceWaiting': 'Pendente - será definido pela R.E.Mobiles',
    'b2b.createdOn': 'Criada em',
    'b2b.clear': 'Limpar',
    'b2b.thisMonth': 'Este mês',
    'b2b.waitingReception': 'Aguarda receção',
    'b2b.received': 'Recebido',
    'b2b.inProgress': 'Em Curso',
    'b2b.waitingParts': 'Aguarda Peças',
    'b2b.completed': 'Concluído',
    'b2b.delivered': 'Entregue',
    // B2B Devis
    'b2bDevis.title': 'Orçamentos deslocação',
    'b2bDevis.pending': 'pendente',
    'b2bDevis.noDevis': 'Sem orçamentos',
    'b2bDevis.noDevisDesc': 'Não tem orçamentos de deslocação de momento.',
    'b2bDevis.travelFee': 'Custos de deslocação',
    'b2bDevis.validationCode': 'Código de validação',
    'b2bDevis.codeHint': 'Introduza o código de 6 dígitos recebido por email.',
    'b2bDevis.acceptFirst': 'Aceite primeiro o orçamento para o poder validar.',
    'b2bDevis.payDeposit': 'Pagar sinal 50%',
    'b2bDevis.payFull': 'Pagar o total',
    'b2bDevis.payRemaining': 'Pagar o restante',
    'b2bDevis.alreadyPaid': 'Já pago',
    'b2bDevis.remaining': 'Valor restante',
    'b2bDevis.invoiceDownload': 'Descarregar fatura',
    'b2bDevis.orderDownload': 'Descarregar nota de encomenda',
    'b2bDevis.quoteDownload': 'Descarregar orçamento',
    // Admin Site Settings
    'adminSettings.title': 'Página inicial',
    'adminSettings.preview': 'Pré-visualizar',
    'adminSettings.saving': 'A guardar...',
    'adminSettings.save': 'Guardar',
    'adminSettings.saved': 'Guardado!',
    'adminSettings.error': 'Erro',
    'adminSettings.heroSection': 'Hero / Cabeçalho',
    'adminSettings.mainTitle': 'Título principal',
    'adminSettings.subtitle': 'Subtítulo',
    'adminSettings.accentColor': 'Cor de destaque (hex)',
    'adminSettings.bgImage': 'Imagem de fundo',
    'adminSettings.change': 'Alterar',
    'adminSettings.companyInfo': 'Informações da empresa',
    'adminSettings.companyName': 'Nome da empresa',
    'adminSettings.companyType': 'Tipo (SAS, SARL...)',
    'adminSettings.capital': 'Capital',
    'adminSettings.rcs': 'RCS',
    'adminSettings.siret': 'SIRET',
    'adminSettings.euid': 'EUID',
    'adminSettings.headquarters': 'Sede',
    'adminSettings.salesPoint': 'Ponto de venda',
    'adminSettings.contactHours': 'Contacto & Horários',
    'adminSettings.phone': 'Telefone',
    'adminSettings.whatsapp': 'WhatsApp',
    'adminSettings.email': 'Email',
    'adminSettings.googleMaps': 'Pesquisa Google Maps',
    'adminSettings.gallery': 'Galeria de fotos',
    'adminSettings.addImage': 'Adicionar imagem',
    // Admin Database
    'adminDb.title': 'Administração da Base de Dados',
    'adminDb.subtitle': 'Exportação, importação e gestão de dados',
    'adminDb.accessDenied': 'Acesso negado',
    'adminDb.adminOnly': 'Esta página é reservada a administradores',
    'adminDb.clients': 'Clientes',
    'adminDb.users': 'Utilizadores',
    'adminDb.repairs': 'Reparações',
    'adminDb.stockArticles': 'Artigos de stock',
    'adminDb.exportTitle': 'Exportar base de dados',
    'adminDb.exportDesc': 'Exportar todos os dados (clientes, utilizadores, stock, reparações, vendas) em formato JSON.',
    'adminDb.exportConfirm': 'Exportar toda a base de dados?',
    'adminDb.exportBtn': 'Exportar base de dados completa',
    'adminDb.exportSuccess': 'Exportação bem-sucedida!',
    'adminDb.exportError': 'Erro durante a exportação',
    'adminDb.importTitle': 'Importar base de dados',
    'adminDb.importDesc': 'Importar um ficheiro JSON para restaurar ou migrar dados.',
    'adminDb.fileSelected': 'Ficheiro selecionado',
    'adminDb.uploading': 'A carregar ficheiro...',
    'adminDb.importDone': 'Importação concluída!',
    'adminDb.importSuccess': 'Importação bem-sucedida!',
    'adminDb.importError': 'Erro durante a importação',
    'adminDb.importClientsBtn': 'Importar clientes',
    'adminDb.importFullBtn': 'Importação completa',
    'adminDb.importWarning': 'A importação completa substituirá os dados existentes',
    'adminDb.importConfirm': 'ATENÇÃO: Esta ação substituirá os dados existentes. Continuar?',
    'adminDb.importClientsConfirm': 'Importar clientes? As contas serão criadas com o número de telefone como identificador.',
    'adminDb.selectFile': 'Selecione um ficheiro',
    'adminDb.selectFileClients': 'Selecione um ficheiro JSON com clientes',
    'adminDb.logsTitle': 'Registo de operações',
    'adminDb.noLogs': 'Nenhuma operação registada',
    // Admin B2B
    'adminB2b.title': 'Gestão B2B',
    'adminB2b.home': 'Início',
    'adminB2b.monthlyRecap': 'Resumo mensal',
    'adminB2b.sending': 'A enviar...',
    'adminB2b.search': 'Pesquisar...',
    'adminB2b.recapTitle': 'Resultado do resumo mensal',
    'adminB2b.recapSent': 'Enviado',
    'adminB2b.recapSkipped': 'Sem reparações',
    'adminB2b.recapError': 'Erro',
    'adminB2b.companies': 'Empresas',
    'adminB2b.b2bRepairs': 'Reparações B2B',
    'adminB2b.paymentHistory': 'Histórico de pagamentos',
    'adminB2b.all': 'Todas',
    'adminB2b.pending': 'Pendentes',
    'adminB2b.validated': 'Validadas',
    'adminB2b.refused': 'Recusadas',
    'adminB2b.suspended': 'Suspensas',
    'adminB2b.noCompany': 'Nenhuma empresa encontrada',
    'adminB2b.phone': 'Telefone',
    'adminB2b.siret': 'SIRET',
    'adminB2b.address': 'Morada',
    'adminB2b.registeredOn': 'Registada em',
    'adminB2b.validatedBy': 'Validada por',
    'adminB2b.downloadKbis': 'Descarregar KBIS',
    'adminB2b.validate': 'Validar',
    'adminB2b.refuse': 'Recusar',
    'adminB2b.suspend': 'Suspender',
    'adminB2b.confirmValidate': 'Deseja validar esta empresa?',
    'adminB2b.confirmRefuse': 'Deseja recusar esta empresa?',
    'adminB2b.confirmSuspend': 'Deseja suspender esta empresa?',
    'adminB2b.pendingReception': 'Aguarda receção',
    'adminB2b.confirmReception': 'Confirmar receção',
    'adminB2b.ref': 'Ref',
    'adminB2b.company': 'Empresa',
    'adminB2b.brandModel': 'Marca / Modelo',
    'adminB2b.problem': 'Problema',
    'adminB2b.delivery': 'Entrega',
    'adminB2b.price': 'Preço',
    'adminB2b.status': 'Estado',
    'adminB2b.actions': 'Ações',
    'adminB2b.noRepairs': 'Nenhuma reparação B2B encontrada',
    'adminB2b.postal': 'Postal',
    'adminB2b.pickup': 'Recolha',
    'adminB2b.inStore': 'Loja',
    'adminB2b.changeStatus': 'Alterar estado',
    'adminB2b.setPrice': 'Definir preço',
    'adminB2b.repairPrice': 'Preço da reparação',
    'adminB2b.diagPrice': 'Preço do diagnóstico',
    'adminB2b.locked': 'Bloqueado (pago)',
    'adminB2b.total': 'Total',
    'adminB2b.existingInvoices': 'Faturas existentes',
    'adminB2b.diagnostic': 'Diagnóstico',
    'adminB2b.repair': 'Reparação',
    'adminB2b.combined': 'Combinada',
    'adminB2b.paidMethod': 'Paga',
    'adminB2b.awaitingPayment': 'Pendente',
    'adminB2b.markPaid': 'Paga',
    'adminB2b.finalize': 'Finalizar faturação',
    'adminB2b.backGlassBroken': 'Vidro tras. partido',
    'adminB2b.clientPart': 'Peça do cliente',
    'adminB2b.bcValidated': 'NE validada',
    'adminB2b.invoiceCancelled': 'Fatura anulada',
    'adminB2b.monthPrompt': 'Mês (1-12)? Deixe vazio para o mês anterior:',
    'adminB2b.yearPrompt': 'Ano?',
    'adminB2b.paymentMethodPrompt': 'Método de pagamento?',
    'adminB2b.filterCompany': 'Empresa',
    'adminB2b.filterDateStart': 'Data início',
    'adminB2b.filterDateEnd': 'Data fim',
    'adminB2b.filter': 'Filtrar',
    'adminB2b.clearFilter': 'Limpar',
    'adminB2b.totalCollected': 'Total cobrado',
    'adminB2b.payments': 'pagamento(s)',
    'adminB2b.payHistoryTitle': 'Histórico de pagamentos B2B',
    'adminB2b.noPayments': 'Nenhum pagamento B2B registado',
    'adminB2b.invoice': 'Fatura',
    // Users Management
    'users.title': 'Gestão de utilizadores',
    'users.count': 'utilizador(es)',
    'users.new': 'Novo utilizador',
    'users.edit': 'Editar utilizador',
    'users.username': 'Nome de utilizador',
    'users.password': 'Palavra-passe',
    'users.newPassword': 'Nova palavra-passe (deixe vazio para não alterar)',
    'users.role': 'Função',
    'users.roleAdmin': 'Administrador',
    'users.roleUser': 'Comercial',
    'users.roleTech': 'Técnico',
    'users.status': 'Estado',
    'users.active': 'Ativo',
    'users.inactive': 'Inativo',
    'users.createdAt': 'Criado em',
    'users.noUsers': 'Sem utilizadores',
    'users.accessDenied': 'Acesso reservado a administradores',
    'users.deleteConfirm': 'Eliminar este utilizador?',
    // Clients (extra keys)
    'clients.manage': 'Gestão de Clientes',
    'clients.total': 'clientes no total',
    'clients.add': 'Adicionar',
    'clients.noClients': 'Nenhum cliente encontrado',
    'clients.type': 'Tipo',
    'clients.discount': 'Desconto',
    'clients.account': 'Conta',
    'clients.sent': 'Enviado',
    'clients.activeAccount': 'Ativo',
    'clients.noEmail': 'Sem email',
    'clients.editClient': 'Editar cliente',
    'clients.newClient': 'Novo cliente',
    'clients.company': 'Empresa',
    'clients.clientType': 'Tipo de cliente',
    'clients.individual': 'Particular',
    'clients.business': 'Empresa',
    'clients.discountPct': 'Desconto (%)',
    'clients.deleteConfirm': 'Eliminar este cliente?',
    'clients.page': 'Página',
    // Stats
    'stats.title': 'Estatísticas & Análises',
    'stats.revenue': 'Volume de negócios',
    'stats.repairs': 'Reparações',
    'stats.b2b': 'B2B',
    'stats.clients': 'Clientes',
    'stats.back': 'Voltar',
    'stats.monthlyRevenue': 'VN mensal',
    'stats.revenueByType': 'VN por tipo',
    'stats.revenueByPayment': 'VN por modo de pagamento',
    'stats.totalRevenue': 'VN total (12 meses)',
    'stats.repairsByStatus': 'Por estado',
    'stats.repairsByBrand': 'Por marca',
    'stats.topModels': 'Top modelos',
    'stats.monthly': 'Evolução mensal',
    'stats.totalRepairs': 'Reparações totais',
    'stats.avgRepairTime': 'Duração média',
    'stats.completionRate': 'Taxa de conclusão',
    'stats.b2bCompanies': 'Empresas B2B',
    'stats.b2bRepairs': 'Reparações B2B',
    'stats.b2bRevenue': 'VN B2B',
    'stats.b2bByCompany': 'Por empresa',
    'stats.totalClients': 'Clientes totais',
    'stats.newThisMonth': 'Novos este mês',
    'stats.withAccount': 'Com conta',
    'stats.clientsByType': 'Por tipo',
    'stats.registrations': 'Registos mensais',
    'stats.noData': 'Sem dados',
    // Reparations (extra)
    'rep.manage': 'Gestão de Reparações',
    'rep.noRepairs': 'Nenhuma reparação encontrada',
    'rep.allStatuses': 'Todos os estados',
    'rep.imei': 'IMEI / Série',
    'rep.client': 'Cliente',
    'rep.phone': 'Tel.',
    'rep.date': 'Data',
    'rep.deposit': 'Sinal',
    'rep.printFiche': 'Imprimir ficha',
    'rep.printEtiquette': 'Imprimir etiqueta',
    'rep.deleteConfirm': 'Eliminar esta reparação?',
    'rep.addDeposit': 'Adicionar sinal',
    'rep.depositAmount': 'Montante do sinal',
    'rep.paymentMode': 'Modo de pagamento',
    'rep.depositHistory': 'Histórico de sinais',
    'rep.totalDeposits': 'Total de sinais',
    'rep.changeStatus': 'Alterar estado',
    'rep.notes': 'Notas internas',
    'rep.sendChat': 'Enviar mensagem',
    'rep.noTimeline': 'Sem eventos',
    // Commandes (extra)
    'cmd.manage': 'Gestão de Encomendas',
    'cmd.noOrders': 'Nenhuma encomenda encontrada',
    'cmd.allStatuses': 'Todos os estados',
    'cmd.ordered': 'Encomendada',
    'cmd.received': 'Recebida',
    'cmd.cancelled': 'Anulada',
    'cmd.status': 'Estado',
    'cmd.ref': 'Ref',
    'cmd.addOrder': 'Nova encomenda',
    'cmd.editOrder': 'Editar encomenda',
    'cmd.deleteConfirm': 'Eliminar esta encomenda?',
    // Stock (extra)
    'stock.manage': 'Gestão de Stock',
    'stock.noItems': 'Nenhum artigo encontrado',
    'stock.barcode': 'Código de barras',
    'stock.reference': 'Referência',
    'stock.alert': 'Alerta',
    'stock.lowStockAlert': 'Stock baixo',
    'stock.addForm': 'Adicionar artigo',
    'stock.editForm': 'Editar artigo',
    'stock.deleteConfirm': 'Eliminar este artigo?',
    // Historique
    'hist.title': 'Histórico de vendas',
    'hist.search': 'Pesquisar uma venda...',
    'hist.noSales': 'Nenhuma venda encontrada',
    'hist.ref': 'Ref.',
    'hist.client': 'Cliente',
    'hist.amount': 'Montante',
    'hist.payment': 'Pagamento',
    'hist.date': 'Data',
    'hist.articles': 'Artigos',
    'hist.refund': 'Reembolsar',
    'hist.refundConfirm': 'Reembolsar esta venda?',
    // Paiements
    'pay.title': 'Pagamentos online',
    'pay.search': 'Pesquisar...',
    'pay.noPayments': 'Nenhum pagamento encontrado',
    'pay.ref': 'Referência',
    'pay.client': 'Cliente',
    'pay.amount': 'Montante',
    'pay.status': 'Estado',
    'pay.date': 'Data',
    'pay.type': 'Tipo',
    // Caisse
    'caisse.title': 'Histórico de Caixas',
    'caisse.noCaisse': 'Nenhuma caixa encontrada',
    'caisse.openedBy': 'Aberta por',
    'caisse.openingAmount': 'Montante de abertura',
    'caisse.closingAmount': 'Montante de fecho',
    'caisse.sales': 'Vendas',
    'caisse.openDate': 'Abertura',
    'caisse.closeDate': 'Fecho',
    // Notes
    'notes.title': 'Notas',
    'notes.new': 'Nova nota',
    'notes.noNotes': 'Sem notas',
    'notes.deleteConfirm': 'Eliminar esta nota?',
    // Etiquettes
    'labels.title': 'Etiquetas',
    'labels.search': 'Pesquisar...',
    'labels.print': 'Imprimir',
    'labels.selectAll': 'Selecionar tudo',
    'labels.noLabels': 'Sem etiquetas',
    // Calcul Prix
    'calc.title': 'Cálculo de Preço',
    'calc.searchDevice': 'Pesquisar um dispositivo...',
    'calc.selectRepair': 'Selecionar uma reparação',
    'calc.generateQuote': 'Gerar orçamento',
    'calc.generateInvoice': 'Gerar fatura',
    // Boutique
    'boutique.title': 'Encomendas Loja',
    'boutique.noOrders': 'Sem encomendas',
    'boutique.orderRef': 'Ref. encomenda',
    'boutique.clientName': 'Cliente',
    'boutique.total': 'Total',
    'boutique.status': 'Estado',
    // Chat
    'chat.title': 'Mensagens',
    'chat.noConversations': 'Sem conversas',
    'chat.typeMessage': 'Escreva a sua mensagem...',
    // Brands & Models
    'brands.title': 'Marcas & Modelos',
    'brands.addBrand': 'Adicionar marca',
    'brands.addModel': 'Adicionar modelo',
    'brands.noBrands': 'Sem marcas',
    'brands.deleteConfirm': 'Eliminar esta marca?',
    // Remcaches
    'remcaches.title': 'Reposições de Cache',
    'remcaches.noItems': 'Sem artigos',
    // Close Caisse
    'closeCaisse.title': 'Fecho de Caixa',
    'closeCaisse.countCoins': 'Contagem de dinheiro',
    'closeCaisse.theoreticalTotal': 'Total teórico',
    'closeCaisse.actualTotal': 'Total real',
    'closeCaisse.difference': 'Diferença',
    'closeCaisse.close': 'Fechar caixa',
    'closeCaisse.closing': 'A fechar...',
    // Client Passwords
    'clientPwd.title': 'Palavras-passe de Clientes',
    'clientPwd.search': 'Pesquisar um cliente...',
    'clientPwd.noClients': 'Nenhum cliente encontrado',
    'clientPwd.generatePin': 'Gerar PIN',
    'clientPwd.sendByEmail': 'Enviar por email',
    // B2B Payments
    'b2bPay.title': 'Pagamentos B2B',
    'b2bPay.noPayments': 'Sem pagamentos',
    // Reparation Form
    'repForm.title': 'Adicionar dispositivo',
    'repForm.editTitle': 'Editar reparação',
    'repForm.brand': 'Marca',
    'repForm.model': 'Modelo',
    'repForm.imei': 'IMEI / N.º de série',
    'repForm.lockCode': 'Código de desbloqueio',
    'repForm.problem': 'Problema constatado',
    'repForm.client': 'Cliente',
    'repForm.technician': 'Técnico atribuído',
    'repForm.price': 'Preço da reparação',
    'repForm.submit': 'Guardar',
    'repForm.submitting': 'A guardar...',
    'sumup.acceptOnlinePayment': 'Aceitar pagamento online (SumUp)', 'sumup.acceptOnlinePaymentDesc': 'O cliente poderá solicitar um link de pagamento SumUp', 'sumup.requestLink': 'Solicitar link de pagamento SumUp', 'sumup.requestSent': 'Pedido enviado! Receberá o link por email.', 'sumup.alreadyRequested': 'Pedido já em curso.', 'sumup.onlinePayment': 'Pagamento online SumUp', 'sumup.receiveLink': 'Receba um link de pagamento seguro por email', 'sumup.linkRequested': 'Link solicitado', 'sumup.pendingRequests': 'Pedidos de link SumUp', 'sumup.pending': 'pendente', 'sumup.pasteLinkHere': 'Colar link SumUp aqui...', 'sumup.send': 'Enviar', 'sumup.linkSent': 'Link SumUp enviado ao cliente por email!',
  };

export default pt;
